var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#FFC876"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 33H18C16.3432 33 15 31.6569 15 30V18C15 16.3432 16.3432 15 18 15H30C31.6569 15 33 16.3432 33 18V30C33 31.6569 31.6569 33 30 33ZM29 20.4142L24.4142 25H26C26.5523 25 27 25.4477 27 26C27 26.5523 26.5523 27 26 27H22C21.4477 27 21 26.5523 21 26V22C21 21.4477 21.4477 21 22 21C22.5523 21 23 21.4477 23 22V23.5858L27.5858 19H26C25.4477 19 25 18.5523 25 18C25 17.4477 25.4477 17 26 17H30C30.5523 17 31 17.4477 31 18V22C31 22.5523 30.5523 23 30 23C29.4477 23 29 22.5523 29 22V20.4142Z",
    fill: "#0E0C15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.0ba9b109cd216ca5131ed95e53d182db.svg";
export { ForwardRef as ReactComponent };